import { isExperimentActive, selectExperiments } from './experiments';
import { QUICK_FILTERS } from '../../constants/config';
import { IApplicationState } from '../../types/redux';

export function selectQuickFiltersGroupBEnabled(state: IApplicationState): boolean {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, QUICK_FILTERS, 'B');
}

export function selectQuickFiltersGroupCEnabled(state: IApplicationState): boolean {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, QUICK_FILTERS, 'C');
}
